module.exports = __webpack_public_path__ + "static/WTP5-554026526109208e0ed4df8abad20b1a.jpg";